import { VerificationStatus, type CharacterCandidate, type PoliticalCharacter, type ThemeId } from '@secretnenshi/shared';
import { getTheme } from './themes';

export { getTheme, getThemeRules, isThemeId, listThemes, type Theme } from './themes';

export function getCharacter(themeId: ThemeId, id: string): PoliticalCharacter | undefined {
  return getTheme(themeId).characters.find((c) => c.id === id);
}

/** Spec §86. Returns the reasons a character may not be used in production. */
export function productionProblems(c: PoliticalCharacter): string[] {
  if (c.fictional) return [];
  const problems: string[] = [];
  if (c.historicalBasis.length < 1) problems.push('no historical basis');
  if (c.sources.length < 1) problems.push('no sources');
  if (c.verificationStatus !== VerificationStatus.VERIFIED) problems.push(`status ${c.verificationStatus}`);
  return problems;
}

/**
 * The pool handed to the engine for an edition. Only mechanical fields leave
 * this package. Real people who fail the source rules are excluded unless
 * allowUnverified is set or the edition is still a preview.
 */
export function getCharacterPool(themeId: ThemeId, options: { allowUnverified: boolean }): CharacterCandidate[] {
  const theme = getTheme(themeId);
  const relaxed = options.allowUnverified || theme.status === 'preview';
  return theme.characters
    .filter((c) => relaxed || productionProblems(c).length === 0)
    .map((c) => ({
      id: c.id,
      faction: c.faction,
      selectionPriority: c.selectionPriority,
      ...(c.specialRole ? { specialRole: c.specialRole } : {}),
    }));
}
